import React from 'react';
import { Link } from 'react-router-dom';
import Offcanvas from 'react-bootstrap/Offcanvas'
import { FaFacebookF, FaLinkedinIn, FaBehance, FaPhone, FaFax } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

const OffcanvasMenu = ({offcanvasShow, offcanvasHide}) => {
    return (
        <Offcanvas show={offcanvasShow} onHide={offcanvasHide} placement="end" className="header-offcanvasmenu">
            <Offcanvas.Header closeButton></Offcanvas.Header>
            <Offcanvas.Body>
                <div className="row ">
                    <div className="col-lg-5 col-xl-6">
                        <ul className="main-navigation list-unstyled">
                            <li><Link to={process.env.PUBLIC_URL + '/'} onClick={offcanvasHide}>Home</Link></li>
                            <li><Link to={process.env.PUBLIC_URL + '/about-us'} onClick={offcanvasHide}>About Us</Link></li>
                            <li><Link to={process.env.PUBLIC_URL + '/products'} onClick={offcanvasHide}>Products</Link></li>
                            <li><a href="https://okepos.com" target="_blank" rel="noreferrer">OOKEY POS</a></li>
                            <li><a href="https://parkir.co.id" target="_blank" rel="noreferrer">OOKEY SmartPark</a></li>
                            <li><a href="https://eduone.id" target="_blank" rel="noreferrer">OOKEY EduONE</a></li>
                            <li><a href="https://komuna.id" target="_blank" rel="noreferrer">OOKEY Komuna</a></li>
                            <li><a href="https://smartbill.id" target="_blank" rel="noreferrer">OOKEY SmartBill</a></li>
                            <li><Link to={process.env.PUBLIC_URL + "/creative-agency"}>Creative Agency</Link></li>
                            <li><Link to={process.env.PUBLIC_URL + "/personal-portfolio"}>Personal Portfolio</Link></li>
                            <li><Link to={process.env.PUBLIC_URL + "/home-startup"}>Home Startup</Link></li>
                            <li><Link to={process.env.PUBLIC_URL + "/corporate-agency"}>Corporate Agency</Link></li>
                        </ul>
                    </div>
                    <div className="col-lg-7 col-xl-6">
                        <div className="contact-info-wrap">
                            <div className="contact-inner">
                                <address className="address">
                                    <span className="title">Contact Information</span>
                                    <p>OOKEY Integrated System<br />Jl. Lawu, Karanganyar</p>
                                </address>
                                <address className="address">
                                    <span className="title">Kami siap membantu Anda</span>
                                    <a href="tel:083899669969" className="tel"><FaPhone /> 0838-9966-9969</a>
                                    <a href="mailto:info@ookey.id" className="tel"><FaFax /> info@ookey.id</a>
                                </address>
                            </div>
                            <div className="contact-inner">
                                <h5 className="title">Find us here</h5>
                                <div className="contact-social-share">
                                    <ul className="social-share list-unstyled">
                                        <li><a href="https://facebook.com/"><FaFacebookF /></a></li>
                                        <li><a href="https://twitter.com/"><FaXTwitter /></a></li>
                                        <li><a href="https://www.behance.net/"><FaBehance /></a></li>
                                        <li><a href="https://www.linkedin.com/"><FaLinkedinIn /></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Offcanvas.Body>
        </Offcanvas>
    )
}

export default OffcanvasMenu;
